export default __webpack_public_path__ + "static/media/dirigent.74c7d403.webp";